<template>
    <div id="cart_section" class="container">
        <div class="row justify-content-center">
            <div class="col-12 row full-content">
                <div class="col-lg-8 carrito-articulos-column">
                    <div class="stick">
                        <div class="block-content lines_block">
                            <h1 class="title">
                                <span>({{ cart.unidades }})</span>
                                {{ cart.unidades | pluralize("Artículo") }} en
                                <span>tu cesta</span>
                            </h1>

                            <load-spiner
                                v-if="!linesCompositeByWeeks"
                            ></load-spiner>
                            <table v-else class="gestionar_orders_block">
                                <div v-for="week in linesCompositeByWeeks">
                                    <tr class="week_text">
                                        <td colspan="7">
                                            <span
                                                >Semana {{ week.week }}
                                                <span
                                                    style="font-weight: 500;font-size: 13px;"
                                                    >{{
                                                        week.weekYear
                                                            | subtitleEnvio
                                                    }}</span
                                                ></span
                                            >
                                        </td>
                                    </tr>
                                    <product-cart-block
                                        v-for="line in week.disponibleLines"
                                        :key="line.id"
                                        :line="line"
                                        :weeks="weeks"
                                    ></product-cart-block>
                                    <product-cart-block
                                        v-for="line in week.customLines"
                                        :key="
                                            'custom-' +
                                                line.id +
                                                '-' +
                                                line.tray.id
                                        "
                                        :line="line"
                                        :weeks="weeks"
                                        custom
                                    ></product-cart-block>
                                </div>

                                <!--                                <div v-for="(info, index) in orders">-->
                                <!--                                    <tr class="week_text">-->
                                <!--                                        <td colspan="7">-->
                                <!--                                            <span>Semana {{index}} <span style="font-weight: 500;font-size: 13px;">{{index|subtitleEnvio}}</span></span>-->
                                <!--                                        </td>-->
                                <!--                                    </tr>-->
                                <!--                                    <product-cart-block v-for="line in info.lineas" :key="line.id" :line="line" :weeks="weeks"></product-cart-block>-->
                                <!--                                    <product-cart-block v-for="line in customLinesBySemana(index)"-->
                                <!--                                                        :key="line.id" :line="line" :weeks="weeks"-->
                                <!--                                    ></product-cart-block>-->
                                <!--                                </div>-->
                            </table>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 carrito-total-column">
                    <div class="stick">
                        <desglose-order-cart
                            :lines-composite-by-weeks="linesCompositeByWeeks"
                            :cart="cart"
                            :nextStepUrl="nextStepUrl"
                            :step="1"
                        ></desglose-order-cart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["nextStepUrl", "cart", "weeks", "linesCompositeByWeeks"],
    data() {
        return {};
    },
    computed: {},
    methods: {},
    mounted() {
        ga("ec:setAction", "checkout", {
            step: 1
        });
        ga("send", "event", "Checkout", "Step 1");
    }
};
</script>

<style scoped>
@media (min-width: 992px) {
    .carrito-articulos-column {
        flex: 0 0 70%;
        max-width: 70%;
    }

    .carrito-total-column {
        flex: 0 0 30%;
        max-width: 30%;
    }
}
</style>
